import React from 'react';
import { FadeIn } from './FadeIn';
import { painPoints } from '../data/landing';
export function ProblemSection() {
  return <section className="py-16 md:py-20 bg-brand-light-sage" data-id="element-139" data-mp="2ltmgzr0xdnkj">
      <div className="max-w-5xl mx-auto px-6" data-id="element-140" data-mp="30gxx8681xvqz">
        <FadeIn data-id="element-141" data-mp="30isjbnv27twn">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest text-center mb-10" data-id="element-142" data-mp="30jalt28bf4d0">
            ¿Te suena familiar?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10" data-id="element-143" data-mp="39gkuqgxnuher">
          {painPoints.map((text, index) => <FadeIn key={index} delay={0.05 * index} className="h-full" data-id="element-144" data-mp="35idedn73zi43" data-mpi={index}>
              <div className="bg-white px-6 py-6 md:py-8 rounded-2xl h-full border-l-4 border-brand-terracotta md:border-l-0 md:border-t-0" data-id="element-145" data-mp="3jfjvldc6p8r7">
                <p className="font-serif text-lg md:text-xl text-brand-charcoal leading-snug" data-id="element-146" data-mp="1p213ij0xaida">
                  {text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.15} data-id="element-147" data-mp="jd3kgf4mzvn7">
          <p className="text-center max-w-xl mx-auto text-lg md:text-xl text-brand-forest font-medium leading-relaxed" data-id="element-148" data-mp="je6daslis85r">
            No necesitas cambiarlo todo de golpe. La guía te acompaña durante
            21 días con acciones pequeñas y concretas.
          </p>
        </FadeIn>
      </div>
    </section>;
}